import { designSystemConfig, type DSC } from '@mentimeter/ragnar-dsc';

export const getThemeFromPropsArray = (props: any[]): DSC => {
  const propsObject = props.length > 0 ? props[0] : {};
  const { theme } = propsObject;

  return theme ?? designSystemConfig;
};
